class NavigationBar {
    constructor() {
        this.navigationElem         = $('#navigation-bar');
        this.navigationElemHeight   = $('#navigation-bar').innerHeight();
        this.navigationLoginElem    = $('.login-nav-item');
        this.navigationItemElem     = $('.nav-item ');
        this.navigationLogoElem     = $('.moody-nav-logo-1');
        this.navigationItemColor    = '#15284C';
        this.navigationLoginContainer = $('.PS_LoginWrapper');
    }

    /**
     * Opens login form on click
     * */
    openLogin (){
        this.navigationLoginContainer.toggle();
    }

    /**
    * Changes navigation bar styles on scroll
    * */
    changeNavigation () {
        let pageScrolled = window.pageYOffset;
        if(pageScrolled > this.navigationElemHeight) {
            this.navigationElem.css({
                "background-color": "white"
            });
            this.navigationLoginElem.css({
                "color": this.navigationItemColor,
                "border-color": this.navigationItemColor
            });
            this.navigationItemElem.css({
                "color": this.navigationItemColor
            });
            this.navigationLogoElem.attr("src", "/img/Logos/MoodyLogoColored.svg");
        } else {
            this.navigationElem.css({
                "background-color": "transparent"
            });
            this.navigationLoginElem.css({
                "color": "white",
                "border-color": "white"
            });
            this.navigationItemElem.css({
                "color": "white"
            });
            this.navigationLogoElem.attr("src", "/img/Logos/Moody-Nav-Logo.png");
        }
    }
}

/**
 * Fixed navigator component
 * */
class FixedNavigator {
    constructor() {
        this.navigator          = $('.navigator-container');
        this.componentContainer = $('.component-container');
        this.activeNavItem      = $('.navigator-container a.orange-active');
        this.logoFdic      = $('#logo-fdic');

        this.removeNavLinkColor();
    }

    /**
     * Removes active class on page load
     * */
    removeNavLinkColor () {
        this.activeNavItem.removeClass('orange-active');
    }

    /**
     * Adjusts position of fixed navigator
     * */
    adjustPosition () {
        let pageScrolled = window.pageYOffset,
            windowHeight = $(document).innerHeight();
        if(pageScrolled < windowHeight - 1700) {
            this.navigator.css({
                "display" : "block",
                "top" : "70%"
            });
        } else {
            this.navigator.css({
                "top" : "10%"
            });
        }
    }

    setLogoFdicSvg() {

    }

    /**
     * Changes navigator link colors based on sections in viewport
     * */
    changeNavLinkColor () {
        let scrollPosition = $(window).scrollTop() + 70;
        this.componentContainer.each(function(i) {
            if ($(this).position().top <= scrollPosition) {
                $('.navigator-container a.orange-active').removeClass('orange-active');
                $('.navigator-container a').eq(i).addClass('orange-active');
            }
        });
    }
}

/**
 * Smooth Scroll Override
 * */
class ScrollOverride {
    constructor() {
        this.linkElem = $('a[href^=#]:not(.lightbox)');
    }

    /**
     * Overrides default scroll
     * @param e
     **/
    smoothScroll (e) {
        e.preventDefault();
        let target = e.currentTarget.hash;

        $('html, body').stop().animate({
            scrollTop: $(target).offset().top - 70
        }, 1000 );
        return false;
    }
}


class MobileNavigation {
    constructor() {
        this.mobileNavigation     = $("#mobile-nav-overlay");
        this.navHamburgerIconElem = $('#hamburger-icon');
        this.navCloseBtnElem      = $('.nav-close-button');
    }

    openMobileNav () {
        this.mobileNavigation.css("height", "100%");
    }

    closeMobileNav () {
        this.mobileNavigation.css("height", "0%");
    }
}


/**
* Initializing objects
*/
window.NavigationBar    = new NavigationBar();
window.FixedNavigator   = new FixedNavigator();
window.ScrollOverride   = new ScrollOverride();
window.MobileNavigation = new MobileNavigation();

/**
 * Event Listeners
 * */
// window.addEventListener('scroll', function() {
//     window.NavigationBar.changeNavigation();
//     window.FixedNavigator.adjustPosition();
//     window.FixedNavigator.changeNavLinkColor();
// });

window.MobileNavigation.navHamburgerIconElem.on('click', () => window.MobileNavigation.openMobileNav());
window.MobileNavigation.navCloseBtnElem.on('click', () => window.MobileNavigation.closeMobileNav());
window.NavigationBar.navigationLoginElem.on('click', () => window.NavigationBar.openLogin());

window.ScrollOverride.linkElem.bind('click', (e) => window.ScrollOverride.smoothScroll(e));






// WEBPACK FOOTER //
// ./resources/assets/js/NavigationBar.js